import { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

//MUI
import { Box } from '@mui/system';
import { UserPermission } from 'constants/user.constants';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { ifCompaniesLoaded } from 'state/reducers/user.reducers';
import { getUi, ifPageChange, setMobile, setPage } from 'state/reducers/ui.reducers';
import { toggleShowKeys, getShowKeys } from 'state/reducers/translation.reducers';
import { useLocation, useNavigate } from 'react-router-dom';
import WaitingMessage from 'components/WaitingMessage';

interface Props {
	children: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
	loadingLanguage: boolean;
	userPermission: UserPermission;
}

function AssetsProvider(props: Props) {
	const isCompaniesLoaded = useAppSelector(ifCompaniesLoaded);
	const dispatch = useAppDispatch();
	const ui = useAppSelector(getUi);
	const ifToNavigate = useAppSelector(ifPageChange);
	const navigate = useNavigate();
	const location = useLocation();
	const isShowTranslationKeys = useAppSelector(getShowKeys);

	window.addEventListener('keydown', (event) => {
		if (event.ctrlKey && event.altKey && event.key === 'q') {
			const showKeys: boolean = isShowTranslationKeys;
			dispatch(toggleShowKeys(!showKeys));
		}
	});

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth < 600) {
				if (!ui.isMobile) {
					dispatch(setMobile(true));
				}
			} else {
				if (ui.isMobile) {
					dispatch(setMobile(false));
				}
			}
		};
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [ui]);

	useEffect(() => {
		if (ifToNavigate && !ui.checkBeforeNavigate) {
			navigate(ui.to);
		}
	}, [ifToNavigate, ui.checkBeforeNavigate]);

	useEffect(() => {
		dispatch(setPage(location.pathname));
		window.scrollTo(0, 0);
	}, [location]);

	return (
		<Fragment>
			{isCompaniesLoaded && props.userPermission !== UserPermission.NONE ? <Box>{props.children}</Box> : <WaitingMessage />}
		</Fragment>
	);
}
export default AssetsProvider;
